// Единая точка вызовов Яндекс.Метрики из SPA. Все вызовы идут под guard window.ym:
// пока Метрика не инициализирована (например, у отказавшихся legacy-cookie declined) это no-op.
declare global {
  interface Window {
    ym?: (id: number, action: string, ...rest: unknown[]) => void
  }
}

export function ymCounter(): number | null {
  const meta = document.querySelector('meta[name="ym-counter"]')
  const raw = meta?.getAttribute('content')
  const id = raw ? Number(raw) : Number.NaN
  return Number.isFinite(id) && id > 0 ? id : null
}

export function reachGoal(goal: string): void {
  if (import.meta.env.DEV) return
  const id = ymCounter()
  if (id && window.ym) window.ym(id, 'reachGoal', goal)
}

export function trackSpaHit(url: string): void {
  if (import.meta.env.DEV) return
  const id = ymCounter()
  if (id && window.ym) window.ym(id, 'hit', url)
}
